<template>
    <div class="modal-out">
        <div class="modal">
            <div class="modal-header">
              <div class="title">添加</div>
              <button type="button" class="btn-close" @click="closeSelf">X</button>
            </div>
            <div class="modal-body">

                <el-row class="row">
                    <el-col :span="12" class="item">
                        <div class="label">公司名称</div>
                        <el-input v-model="add_name" placeholder="请输入公司名称"></el-input>
                    </el-col>
                  <el-col :span="12" class="item">
                    <div class="label">联系人</div>
                    <el-input v-model="add_contacts" placeholder="请输入联系人"></el-input>
                  </el-col>
                </el-row>

                <el-row class="row">
                  <el-col :span="12" class="item">
                    <div class="label">电话(登录账号)</div>
                    <el-input v-model="add_phone" placeholder="请输入电话"></el-input>
                  </el-col>
                  <el-col :span="12" class="item">
                    <div class="label">登录密码</div>
                    <el-input v-model="add_password" placeholder="请输入密码"></el-input>
                  </el-col>
                </el-row>

              <el-row class="row">
                <el-col :span="12" class="item">
                  <div class="label">地址</div>
                  <el-input v-model="add_address" placeholder="请输入公司地址"></el-input>
                </el-col>
                <el-col :span="12" class="item">
                  <div class="label">经纬度</div>
                    <el-input v-model="lonlatstr" disabled placeholder="请抓取经纬度" class="homeAddress">
                      <el-button slot="append" @click="openBaiduMap">抓取</el-button>
                    </el-input>
                </el-col>
              </el-row>

            </div>
            <div class="modal-footer">
                <el-button :loading="loading" type="primary" @click.native="confirm">确认</el-button>
            </div>
        </div>

      <BaiduMap ref="myBaiduMap" v-show="baiduMapShow"
                v-on:colseMap="closeMap"
                v-on:setMap="setMap"></BaiduMap>

    </div>
</template>


<script>

    import {getStaffCode} from "@/utils/auth";
    import {timeStr} from "@/common/times";
    import {hex_md5} from "@/common/Base64MD5";

    import BaiduMap from "./BaiduMap";


    export default {
        name: 'Add',
        props: ['roleValue'],
        data() {
            return {

                baiduMapShow: false,
                loading: false,

                add_name:'',
                add_phone:'',
                add_contacts:'',
                add_address:'',
              add_password:'',

              lon:'',
              lat:'',

              lonlatstr:'',

            }
        },
        components: {
            BaiduMap
        },
        methods: {
            init(){

                this.add_name = '';
                this.add_phone = '';
                this.add_contacts = '';
                this.add_address = '';
                this.add_password = '';

              this.lonlatstr = '';

            },

            closeSelf() {
                this.$emit("closeAdd");
            },

          openBaiduMap() {
            this.$refs.myBaiduMap.init();
            this.baiduMapShow = true;
          },
          closeMap() {
            this.baiduMapShow = false
          },

          setMap(info) {
            this.baiduMapShow = false

            let gcLonLat = this.bMapTransWXMap(info.lng,info.lat);
            this.lon = gcLonLat[0];
            this.lat = gcLonLat[1];

            this.lonlatstr = info.lng +","+info.lat;

          },


            confirm(){

                if(this.add_name == ''){
                  this.$message.info("填写名称");
                  return;
                }
                if(this.add_phone == ''){
                  this.$message.info("填写手机号");
                  return;
                }
                if(this.add_contacts == ''){
                  this.$message.info("填写联系人");
                  return;
                }
                if(this.add_address == ''){
                  this.$message.info("填写地址");
                  return;
                }

              if(this.add_password == ''){
                this.$message.info("填写密码");
                return;
              }
              if(this.add_password.length<6 || this.add_password.length>20){
                this.$message.info("密码长度为6至20位");
                return;
              }

              if(this.lon == ''){
                this.$message.info("选择经纬度");
                return;
              }



              if(this.loading){
                return;
              }else{
                this.loading = true;
              }

              this.$axios({
                  method: 'post',
                  url: this.$shopUrl+'Government/AddByAdmin',
                  data: {
                      timeStr:timeStr,
                      sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
                      staffCode: getStaffCode(),

                      name: this.add_name,
                      phone:this.add_phone,
                      contacts:this.add_contacts,
                      address:this.add_address,
                      password:this.add_password,
                    lon:this.lon,
                    lat:this.lat,
                  }
              }).then( (response)=> {
                  //console.log(response.data);
                  this.loading = false;

                  if(response.data.error == 0){
                      this.$emit("closeAdd");
                      this.$emit("getList");
                  }else if(response.data.error == 1){
                      this.$message(response.data.message);
                  }else{
                      console.log(response.data.message);
                  }

              }).catch(function (error) {
                  console.log(error);
              });

            },


          // GCJ-02 to BD-09
          bd_encrypta(gg_lon, gg_lat) {
            var X_PI = Math.PI * 3000.0 / 180.0;
            var x = gg_lon, y = gg_lat;
            var z = Math.sqrt(x * x + y * y) + 0.00002 * Math.sin(y * X_PI);
            var theta = Math.atan2(y, x) + 0.000003 * Math.cos(x * X_PI);
            var bd_lon = z * Math.cos(theta) + 0.0065;
            var bd_lat = z * Math.sin(theta) + 0.006;
            return [bd_lon, bd_lat]
          },

          // BD-09 to GCJ-02
          bMapTransWXMap(lng, lat) {
            let x_pi = 3.14159265358979324 * 3000.0 / 180.0;
            let x = lng - 0.0065;
            let y = lat - 0.006;
            let z = Math.sqrt(x * x + y * y) - 0.00002 * Math.sin(y * x_pi);
            let theta = Math.atan2(y, x) - 0.000003 * Math.cos(x * x_pi);
            let lngs = z * Math.cos(theta);
            let lats = z * Math.sin(theta);
            return [lngs, lats]
          },



        }
    }
</script>


<style  lang="scss" scoped>

</style>
